module.exports = __webpack_public_path__ + "static/media/6COPUOS1.c0f78c70.jpg";